// Single-image build: the Firebase web config is not compiled into the bundle.
// The backend serves /env.js (window.__SCHOOL_ENV__) for the tenant it runs and
// index.html loads it before the bundles. Source of the values:
// backend/config/web/<project_id>.json. Local development keeps environment.ts.
if (!(window as any).__SCHOOL_ENV__ || !(window as any).__SCHOOL_ENV__.firebase) {
    throw new Error('School App: /env.js did not load, no Firebase web config for this instance');
}

export const environment = {
    production: (window as any).__SCHOOL_ENV__.production !== false,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: (window as any).__SCHOOL_ENV__.firebase
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts